"use strict";

exports.__esModule = true;
exports.scheduledStateFilter = exports.scheduledActivityFilter = exports.rangeFilter = exports.plantFilter = exports.operatorFilter = exports.excludeDaysInWeek = exports.deviceFilter = void 0;
var daysInWeek = [{
  id: 1,
  label: "Mo"
}, {
  id: 2,
  label: "Tu"
}, {
  id: 3,
  label: "We"
}, {
  id: 4,
  label: "Th"
}, {
  id: 5,
  label: "Fr"
}, {
  id: 6,
  label: "Sa"
}, {
  id: 7,
  label: "Su"
}];
var excludeDaysInWeek = exports.excludeDaysInWeek = {
  name: "exclude_days_of_week",
  label: "Exclude days of week",
  filterGroup: "must",
  filterType: "script",
  options: {
    scriptName: "exclude_days_of_week",
    scriptParams: {
      daysToExclude: []
    }
  },
  props: {
    type: "array",
    subType: "string",
    section: "filters",
    valuePath: "options.scriptParams.daysToExclude",
    dependsOn: [],
    values: {
      source: "input",
      data: daysInWeek
    },
    presentation: {
      showInToolbar: true,
      showInEditor: true,
      component: "ButtonGroup"
    }
  }
};
var scheduledStateFilter = exports.scheduledStateFilter = function scheduledStateFilter(states) {
  var scheduledStates = states.filter(function (state) {
    return state.show;
  }).map(function (state) {
    return Object.assign({}, state, {
      label: state.name
    });
  });
  return {
    name: "scheduledStates",
    label: "States from Calendar Schedule",
    filterGroup: "must",
    filterType: "terms",
    fieldName: "dimensions.scheduled_state",
    values: [],
    props: {
      type: "array",
      subType: "string",
      section: "filters",
      valuePath: "values",
      dependsOn: [],
      values: {
        source: "select",
        path: ["id"],
        data: scheduledStates
      },
      presentation: {
        showInToolbar: true,
        showInEditor: true,
        component: "Selector",
        multiSelect: true
      }
    }
  };
};
var scheduledActivityFilter = exports.scheduledActivityFilter = function scheduledActivityFilter(activities) {
  var scheduledActivities = activities.filter(function (activity) {
    return activity.show;
  }).map(function (activity) {
    return Object.assign({}, activity, {
      label: activity.name
    });
  });
  return {
    name: "scheduledActivities",
    label: "Activities from Calendar Schedule",
    filterGroup: "must",
    filterType: "terms",
    fieldName: "dimensions.scheduled_activity",
    values: [],
    props: {
      type: "array",
      subType: "string",
      section: "filters",
      valuePath: "values",
      dependsOn: [],
      values: {
        source: "select",
        path: ["id"],
        data: scheduledActivities
      },
      presentation: {
        showInToolbar: true,
        showInEditor: true,
        component: "Selector",
        multiSelect: true
      }
    }
  };
};
var operatorFilter = exports.operatorFilter = {
  name: "operator",
  filterGroup: "any",
  label: "Operator Value",
  filterType: "exists",
  fieldName: "dimensions.operator",
  props: {
    section: "filters",
    valuePath: null,
    dependsOn: [],
    values: {
      source: "input",
      data: [{
        id: "",
        label: "None"
      }, {
        id: "must",
        label: "Operator is present"
      }, {
        id: "mustNot",
        label: "Operator is not present"
      }],
      defaultSelected: [{
        id: "",
        label: "None"
      }]
    },
    setType: function setType(filter) {
      return filter.id;
    },
    presentation: {
      showInToolbar: true,
      showInEditor: true,
      component: "Selector"
    }
  }
};
var deviceFilter = exports.deviceFilter = {
  name: "device",
  label: "Device",
  filterGroup: "must",
  filterType: "terms",
  fieldName: "entity.device",
  values: [],
  props: {
    section: "filters",
    valuePath: "values",
    dependsOn: [],
    values: {
      source: "device",
      path: ["uuid"]
    },
    presentation: {
      showInToolbar: true
    }
  }
};
var plantFilter = exports.plantFilter = {
  name: "plant",
  label: "Plant",
  filterGroup: "must",
  filterType: "term",
  fieldName: "entity.plant",
  values: "",
  props: {
    section: "filters",
    valuePath: "values",
    dependsOn: [],
    values: {
      source: "plant"
    },
    presentation: {
      showInToolbar: false
    }
  }
};
var rangeFilter = exports.rangeFilter = {
  name: "dateRange",
  label: "Date Range",
  filterGroup: "must",
  filterType: "range",
  fieldName: "timestamp",
  values: {
    gte: "",
    lt: ""
  },
  props: {
    section: "filters",
    valuePath: "values",
    dependsOn: [],
    values: {
      source: "WorkdayRangeSelector"
    },
    presentation: {
      showInToolbar: true
    }
  }
};